export default function ({ $axios, route, app, store, redirect }) {
  $axios.onError((error) => {

    if (error.response && ([400, 401, 422, 500, 502].includes(error.response?.status))) {
      const errorMessage = `[API] Request to ${error.config.url} failed with status ${error.response.status}`;

      let req = error.config.data
      try {
        req = JSON.parse(error.config.data)
      } catch (e) {

      }
      // Добавляем тело запроса и ответа в сообщение об ошибке
      const errorDetails = {
        message: errorMessage,
        request: req, // Тело запроса
        response: error.response.data, // Тело ответа
      };

      console.error(errorDetails);

      // Отправляем ошибку в Sentry с дополнительными данными (с проверками наличия инстансов)
      if (app.$sentry && typeof app.$sentry.captureException === 'function') {
        app.$sentry.captureException(error, { extra: errorDetails });
      }
      if (app.$sentryServer && typeof app.$sentryServer.captureException === 'function') {
        app.$sentryServer.captureException(error, { extra: errorDetails });
      }
    }

    return Promise.reject(error);
  });
}

